import { SerializedFarmConfig } from '@pancakeswap/farms'
import { bscTokens } from '@pancakeswap/tokens'

const farms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 2, 3) should always be at the top of the file.
   */

   {
    pid: 0,
    lpSymbol: 'PiB',
    lpAddress: '0x45b19b46Be1B9006F388873E2C460FCcc7d00F15',
    token: bscTokens.busd,
    quoteToken: bscTokens.pib,
  },
  {
    pid: 1,
    lpSymbol: 'BUSD-PiB LP',
    lpAddress: '0x78d418652d57300044bB34DC855335438497BABf',
    token: bscTokens.pib,
    quoteToken: bscTokens.busd,
    boosted: false
  },
  {
    pid: 2,
    lpSymbol: 'WPi-BUSD LP',
    lpAddress: '0xf6213F3fFA22D9a6C08b024E93409a9Dd936C0F5',
    token: bscTokens.wpi,
    quoteToken: bscTokens.busd,
    boosted: false
  },
].map((p) => ({ ...p, token: p.token.serialize, quoteToken: p.quoteToken.serialize }))


export default farms
